import { MANAGE_GROUP_API } from "../helpers/api-path";
import httpClient from "./http.interceptor";
// group API

const createGroupAPI = async (formData) => {
    const operation = "createGroup";
    return groupLambdaAPI(operation, formData)
}

const getUserGroupsAPI = async (formData) => {
    const operation = "listGroupsForUser";
    return groupLambdaAPI(operation, formData)
}

const listUsersInGroupAPI = async (formData) => {
    const operation = "listUsersInGroup";
    return groupLambdaAPI(operation, formData)
}

const addUserToGroupAPI = async (formData) => {
    const operation = "addUserToGroup";
    return groupLambdaAPI(operation, formData)
}

const removeUserToGroupAPI = async (formData) => {
    const operation = "removeUserFromGroup";
    return groupLambdaAPI(operation, formData)
}

const groupLambdaAPI = async (operation, formData) => {
    const requestBody = {
        operation,
        params: {
            ...formData
        }
    }
    const URL = MANAGE_GROUP_API+"?environment="+process.env.REACT_APP_ENVIRONMENT;
    return await httpClient.post(URL, { ...requestBody });
}

export {
    getUserGroupsAPI,
    addUserToGroupAPI,
    removeUserToGroupAPI,
    listUsersInGroupAPI,
    createGroupAPI,
}